import(/* webpackMode: "eager" */ "/codebuild/output/src3919939449/src/next-app/app/global-error.tsx");
